import React, { Component } from 'react';
import { TextField, Checkbox, FormControlLabel, Grid } from '@material-ui/core';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import * as Actions from './store/actions';
import { withStyles } from '@material-ui/core/styles';
import * as validatorActions from '../../components/validator/store/actions'
import ComponentTrackingInfo from '../../components/ComponentTrackingInfo';
import { getSharedTextFieldProps } from '../../components/helpers';
import moment from 'moment'

const styles = theme => ({
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        width: '80%',
    },
    textFieldSearch: {
        marginLeft: theme.spacing.unit,
        width: '95%',
    },
    button: {
        margin: theme.spacing.unit,
    },
    editor: {
        "min-height": "150px"
    },
    root: {
        backgroundColor: theme.palette.background.paper,
        width: 500,
    },
    readOnlyMargin: {
        marginLeft: '16px'
    },
    hiddenWhenEmptyValue: {
        display: 'none'
    },
});

class StudentForm extends Component {

    handleChange = field_name => event => {
        let value = event.target.value;
        if (event.target.type === 'checkbox') {
            value = event.target.checked ? 1 : 0;
        }

        const update_data = {
            [field_name]: value
        }
        const validator = {
            field_name, value
        }

        this.props.runValidator(validator)
        this.props.updateStudentForm(update_data);
    }

    render() {
        const { classes, student, view_type, validator } = this.props

        const passwordCreate = (prop) => {
            if (prop) {
                return (
                    <Grid item xs={12}>
                        <TextField
                            required
                            id="Password"
                            label="Password"
                            className={classes.textField}
                            value={student.Password}
                            onChange={this.handleChange('Password')}
                            margin="normal"
                            variant="outlined"
                            type="password"
                            // error={this.fieldHasError(validator.filter(v => v.field_name === 'Password'))}
                            error={student.Password != student.PasswordConfirm || validator.filter(v => v.field_name === 'Password')[0].error}
                            helperText={validator.filter(v => v.field_name === 'Password')[0].error_msg}
                        />
                        <TextField
                            required
                            id="PasswordConfirm"
                            label="Password Confirm"
                            className={classes.textField}
                            value={student.PasswordConfirm}
                            onChange={this.handleChange('PasswordConfirm')}
                            margin="normal"
                            variant="outlined"
                            type="password"
                            error={student.Password != student.PasswordConfirm || validator.filter(v => v.field_name === 'PasswordConfirm')[0].error}
                            // error={this.fieldHasError(validator.filter(v => v.field_name === 'PasswordConfirm'))}
                            helperText={"Must match the 'Password' field"}
                        />
                    </Grid>
                )
            }
        }

        return (
            <div className="p-24">
                <Grid container spacing={24}>
                    <Grid item xs={6}>
                        <form className={classes.container} noValidate autoComplete="off">
                            <Grid item xs={12}>
                                <TextField
                                    required
                                    id="FirstName"
                                    label="First Name"
                                    value={student.FirstName}
                                    onChange={this.handleChange('FirstName')}
                                    error={validator.filter(v => v.field_name === 'FirstName')[0].error}
                                    helperText={validator.filter(v => v.field_name === 'FirstName')[0].error_msg}
                                    {...getSharedTextFieldProps(view_type, classes)}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    required
                                    id="LastName"
                                    label="Last Name"
                                    value={student.LastName}
                                    onChange={this.handleChange('LastName')}
                                    error={validator.filter(v => v.field_name === 'LastName')[0].error}
                                    helperText={validator.filter(v => v.field_name === 'LastName')[0].error_msg}
                                    {...getSharedTextFieldProps(view_type, classes)}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    required
                                    id="Email"
                                    label="Email"
                                    value={student.Email}
                                    onChange={this.handleChange('Email')}
                                    error={validator.filter(v => v.field_name === 'Email')[0].error}
                                    helperText={validator.filter(v => v.field_name === 'Email')[0].error_msg}
                                    {...getSharedTextFieldProps(view_type, classes)}
                                />
                            </Grid>

                            <Grid item xs={12}>
                                <TextField
                                    id="Address"
                                    label="Address"
                                    value={student.Address}
                                    onChange={this.handleChange('Address')}
                                    {...getSharedTextFieldProps(view_type, classes)}
                                    className={(student.Address === (undefined || '') && view_type === 'detail') ? [classes.hiddenWhenEmptyValue, classes.textField] : classes.textField}
                                />
                            </Grid>

                            <Grid item xs={12}>
                                <TextField
                                    id="City"
                                    label="City"
                                    value={student.City}
                                    onChange={this.handleChange('City')}
                                    {...getSharedTextFieldProps(view_type, classes)}
                                    className={(student.City === (undefined || '') && view_type === 'detail') ? [classes.hiddenWhenEmptyValue, classes.textField] : classes.textField}
                                />
                            </Grid>

                            <Grid item xs={12}>
                                <TextField
                                    id="State"
                                    label="State"
                                    value={student.State}
                                    onChange={this.handleChange('State')}
                                    {...getSharedTextFieldProps(view_type, classes)}
                                    className={(student.State === (undefined || '') && view_type === 'detail') ? [classes.hiddenWhenEmptyValue, classes.textField] : classes.textField}
                                />
                            </Grid>

                            <Grid item xs={12}>
                                <TextField
                                    id="Zip"
                                    label="Zip"
                                    value={student.Zip}
                                    onChange={this.handleChange('Zip')}
                                    {...getSharedTextFieldProps(view_type, classes)}
                                    className={(student.Zip === (undefined || '') && view_type === 'detail') ? [classes.hiddenWhenEmptyValue, classes.textField] : classes.textField}
                                />
                            </Grid>

                            <Grid item xs={12}>
                                <TextField
                                    id="Phone"
                                    label="Phone"
                                    value={student.Phone}
                                    onChange={this.handleChange('Phone')}
                                    {...getSharedTextFieldProps(view_type, classes)}
                                    className={(student.Phone === (undefined || '') && view_type === 'detail') ? [classes.hiddenWhenEmptyValue, classes.textField] : classes.textField}
                                />
                            </Grid>
                            
                            {passwordCreate(this.props.view_type === 'create')}
                            <Grid item xs={12}>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            style={{ marginLeft: '10px' }}
                                            checked={(student.Active === 1 || student.Active === true)}
                                            onChange={(view_type === 'detail') ? undefined : this.handleChange('Active')}
                                            disableRipple={view_type === 'detail'}
                                            value="Active"
                                            color="primary"
                                        />
                                    }
                                    label="Active"
                                    className={(view_type === 'detail') ? classes.hiddenWhenEmptyValue : undefined}
                                />
                            </Grid>
                        </form>
                    </Grid>
                    <Grid item xs={6}>
                        <ComponentTrackingInfo
                            editInfo={this.props.editInfo}
                            view_type={this.props.view_type}
                            classes={classes}
                        />
                        {view_type === 'detail' ? 
                            <Grid item xs={12}>
                                <TextField
                                    id="LastLogin"
                                    label="Last Login"
                                    // value={moment(student.LastLogin).format('YYYY-MM-DD HH:mm') || 'None'}
                                    value={student.LastLogin}
                                    onChange={this.handleChange('Zip')}
                                    {...getSharedTextFieldProps(view_type, classes)}
                                    className={(student.LastLogin === (undefined || '') && view_type === 'detail') ? [classes.hiddenWhenEmptyValue, classes.textField] : classes.textField}
                                />
                            </Grid>
                            : null }
                    </Grid>
                </Grid>
            </div>
        )
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getStudent: Actions.getStudent,
        saveStudent: Actions.saveStudent,
        deleteStudent: Actions.deleteStudent,
        getStudentList: Actions.getStudentList,
        updateStudentForm: Actions.updateStudentForm,
        runValidator: validatorActions.runValidator
    }, dispatch);
}

function mapStateToProps({ studentApp, auth, validator }) {
    return {
        student: studentApp.students.currentStudent,
        auth,
        validator: validator.list,
        editInfo: studentApp.students.editInfo
    }
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(StudentForm)));



// WEBPACK FOOTER //
// src/main/content/student/StudentForm.js